import React from 'react';
import PropTypes from 'prop-types';
import Video from '../../../components/BrightcoveVideo';
import { HowToPanelWrapper, TitleWrapper, ContentList, Content } from './HowToPanel.style';

const HowToPanel = ({ data }) => (
  <HowToPanelWrapper>
    <TitleWrapper>{data.title}</TitleWrapper>
    <ContentList>
      {data.contents.map(item => (
        <Content>
          {(() => {
            if (item.movie) {
              return (
                <Video
                  {...item.movie}
                  style={{
                    width: '250px',
                    height: '250px',
                    border: '0',
                  }}
                />
              );
            }
            return <img src={item.image.file.url} alt={item.image.title} />;
          })()}
          <p>
            {item.file ? (
              <a href={item.file.file.url} target="_blank">
                {item.title}
              </a>
            ) : (
              item.title
            )}
          </p>
        </Content>
      ))}
    </ContentList>
  </HowToPanelWrapper>
);

HowToPanel.defaultProps = {
  data: [],
};

HowToPanel.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
};

export default HowToPanel;



// WEBPACK FOOTER //
// ./src/pages/RangePage/HowToPanel/HowToPanel.js